import { ClaimType } from "src/app/pages/store-management/claims/claim-model";

// Development environment. Substituted in via the angular.json `development`
// configuration's fileReplacements.
export const environment = {
  i18nAssetVersion: "20261102",
  baseApiUrl: "https://dev-api.treeslo.com",
  baseAppUrl: "https://dev.treeslo.com",
  oAuthDomain: "dev-identity.treeslo.com",
  awsRegion: "us-east-2",
  cognitoUserPoolId: "us-east-2_xmALPSDjG",
  cognitoUserPoolClientId: "3jhaduj4i7bg8isnp70oaeipck",
  websocketUrl: "wss://dev-socket-api.treeslo.com/",

  /** Temporary: duplicate the first store to preview multi-tab billing UI. */
  mockExtraBillingStore: false,

  /** Dev-only: show WebSocket on/off control in the notifications bell menu. */
  devWebSocketToggleEnabled: true,
  enableSharedStores: true,

  /** Max requests kept in the Ops Console HTTP inspector history (oldest evicted first). */
  opsHttpInspectorHistoryLimit: 10,

  STRIPE_PUBLISHABLE_KEY:
    "pk_test_51MM9ObJ9h1Lu75vVYG8T1Vw3V1SiUkSZhtafct8SyF8p1GDUT2E79cLNPavebrHH0R8pvl9AccN3u8sOFryaWUpL00l2pVdZfc",
  // "pk_test_51RlvpgP7OAPb0OKv3L1J7kqmCQvlyh1rK8IhYbyQg3RXfL13Ad5Fbw6Rio4qDQpNqieRtdoPCfywNSXTp86S0loa008F6EK3oU",

  docTypes: {
    PURCHASE_INVOICE: "PURCHASE_INVOICE",
    PACKING_SLIP: "PACKING_SLIP",
    BILL_OF_LADING: "BILL_OF_LADING",
  },

  // viewContextHistoryStateLimit: 10,
  // maxSizeFileUpload: 10 * 1024 * 1024, // 10 MB
  // AllowedFilesAmountPerTicket: 8,

  sideNavLabelTruncateLength: 18,

  claimsTypesNavItems: [
    {
      provider: "amazon",
      children: [
        {
          displayName: "Damaged Inventory",
          shortDescription: "side_menu.damaged_short",
          Description: "side_menu.damaged_desc",
          tags: [
            "damaged",
            "inventory",
            "harm",
            "quality",
            "dañado",
            "inventario",
            "daño",
            "calidad",
          ],
          // use a box or alert icon to indicate damage; "box-closed" isn't in Tabler,
          // switch to a valid name such as "box" or "package"
          iconName: "box",
          route: "/claim/damaged-inventory",
        },
        {
          displayName: "Refund Never Returned Claim",
          shortDescription: "side_menu.refund_short",
          Description: "side_menu.refund_desc",
          tags: [
            "refund",
            "return",
            "missing",
            "payment",
            "reembolso",
            "devolución",
            "faltante",
            "pago",
          ], // Tabler doesn’t have x-circle; use "ban" or "alert-circle" instead
          iconName: "ban",
          route: "/claim/refund-never-returned-claim",
        },
        {
          displayName: "Reanalysis",
          shortDescription: "side_menu.reanalysis_short",
          Description: "side_menu.reanalysis_desc",
          tags: [
            "evaluation",
            "review",
            "reconsider",
            "appeal",
            "evaluación",
            "revisión",
            "reconsideración",
            "apelación",
          ],
          // a refresh/redo icon fits reanalysis
          iconName: "refresh",
          route: "/claim/reanalysis",
        },
        {
          displayName: "Lost Outbound Claim",
          shortDescription: "side_menu.lost_outbound_short",
          Description: "side_menu.lost_outbound_desc",
          tags: [
            "lost",
            "outbound",
            "shipment",
            "delivery",
            "perdido",
            "saliente",
            "envío",
            "entrega",
          ],
          // use a truck or map-pin to indicate lost shipment
          iconName: "truck-delivery",
          route: "/claim/lost-outbound",
        },
        {
          displayName: "Lost Inbound (Guide)",
          shortDescription: "side_menu.lost_inbound_short",
          Description: "side_menu.lost_inbound_desc",
          tags: [
            "lost",
            "inbound",
            "guide",
            "inventory",
            "perdido",
            "entrante",
            "guía",
            "inventario",
          ],
          // truck-delivery flipped horizontally to indicate inbound direction
          iconName: "truck-delivery",
          iconClass: "flip-horizontal",
          route: "/claim/lost-inbound-guide",
        },
        {
          displayName: "Storage Fees",
          shortDescription: "side_menu.storage_fees_short",
          Description: "side_menu.storage_fees_desc",
          tags: [
            "storage",
            "fees",
            "charges",
            "warehouse",
            "almacenamiento",
            "cuotas",
            "cargos",
            "almacén",
          ],
          iconName: "package",
          route: "/claim/storage-fees",
        },
      ],
    },

    //Demos for Walmart claims types, can be expanded with real types when available.
    {
      provider: "walmart",
      children: [
        {
          displayName: "Damaged Inventory 2",
          shortDescription: "side_menu.damaged_short",
          Description: "side_menu.damaged_desc",
          tags: [
            "damaged",
            "inventory",
            "harm",
            "quality",
            "dañado",
            "inventario",
            "daño",
            "calidad",
          ],
          // use a box or alert icon to indicate damage; "box-closed" isn't in Tabler,
          // switch to a valid name such as "box" or "package"
          iconName: "box",
          route: "/claim/damaged-inventory",
        },
      ],
    },
  ],
};
